import { useState } from "react";
import { api, errText } from "../lib/api";

const COPY = {
  fr: { link: "Mot de passe oublié ?", hint: "Saisissez votre e-mail, nous vous envoyons un lien de réinitialisation.", send: "Envoyer le lien", cancel: "Annuler", done: "Si un compte existe pour cet e-mail, un lien vient d'être envoyé (vérifiez vos spams)." },
  en: { link: "Forgot password?", hint: "Enter your email and we will send you a reset link.", send: "Send reset link", cancel: "Cancel", done: "If an account exists for this email, a reset link is on its way (check spam too)." },
  es: { link: "¿Olvidaste tu contraseña?", hint: "Introduce tu e-mail y te enviaremos un enlace.", send: "Enviar enlace", cancel: "Cancelar", done: "Si existe una cuenta con este e-mail, acabamos de enviar un enlace (revisa el spam)." },
  ar: { link: "هل نسيت كلمة المرور؟", hint: "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.", send: "إرسال الرابط", cancel: "إلغاء", done: "إذا كان هناك حساب بهذا البريد، فقد أرسلنا رابطًا الآن (تحقق من البريد غير الهام)." },
  it: { link: "Password dimenticata?", hint: "Inserisca la sua email e le invieremo un link per reimpostare la password.", send: "Invia link di reimpostazione", cancel: "Annulla", done: "Se esiste un account per questa email, un link di reimpostazione è in arrivo (controli anche la cartella spam)." },
  nl: { link: "Wachtwoord vergeten?", hint: "Vul uw e-mailadres in en we sturen u een link om uw wachtwoord opnieuw in te stellen.", send: "Resetlink versturen", cancel: "Annuleren", done: "Als er een account bestaat voor dit e-mailadres, is een resetlink onderweg (check ook uw spammap)." },
  de: { link: "Passwort vergessen?", hint: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen.", send: "Reset-Link senden", cancel: "Abbrechen", done: "Falls ein Konto für diese E-Mail-Adresse existiert, ist ein Reset-Link unterwegs (prüfen Sie auch Ihren Spam-Ordner)." },
};

// Inline "forgot password" for the florist / driver / admin login cards. Neutral wording: never reveals whether the email exists.
export function ForgotPasswordLink({ locale = "fr", email = "", testid = "forgot-password" }) {
  const c = COPY[locale] || COPY.fr;
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(email);
  const [state, setState] = useState({ busy: false, done: false, error: "" });
  const send = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    setState({ busy: true, done: false, error: "" });
    try {
      await api.post("/auth/forgot-password", { email: value.trim(), origin_url: window.location.origin, locale });
      setState({ busy: false, done: true, error: "" });
    } catch (err) { setState({ busy: false, done: false, error: errText(err) }); }
  };
  if (!open) {
    return (
      <button type="button" data-testid={`${testid}-link`} className="text-xs text-muted underline block w-full text-center"
              onClick={() => { setValue(email); setOpen(true); }}>{c.link}</button>
    );
  }
  return (
    <div className="space-y-2 border-t border-brass-light pt-3" data-testid={`${testid}-panel`}>
      <p className="text-xs text-muted">{c.hint}</p>
      {state.done ? (
        <p className="text-xs text-success" data-testid={`${testid}-done`}>{c.done}</p>
      ) : (
        <div className="flex gap-2">
          <input data-testid={`${testid}-email`} className="field flex-1" type="email" placeholder="E-mail" value={value} onChange={(e) => setValue(e.target.value)} />
          <button type="button" data-testid={`${testid}-send`} className="btn-primary text-xs px-3" disabled={state.busy} onClick={send}>{state.busy ? "…" : c.send}</button>
        </div>
      )}
      {state.error ? <p className="text-danger text-xs" data-testid={`${testid}-error`}>{state.error}</p> : null}
      <button type="button" className="text-xs text-muted underline" onClick={() => setOpen(false)}>{c.cancel}</button>
    </div>
  );
}
